import { useEffect } from "react";
import Reveal from "../components/Reveal";
import PageSEO from "../components/PageSEO";

const SITE_URL = "https://artistryperspectives.com";

export default function AI() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "AI — Artistry Perspectives";
  }, []);

  return (
    <main data-testid="ai-page" className="bg-[#0A0A0C] min-h-screen">
      <PageSEO
        title="AI — Artistry Perspectives"
        description="Craft, meet code. Where our editorial thinking meets emerging AI tools."
        url={`${SITE_URL}/ai`}
      />
      <section className="px-6 md:px-14 lg:px-24 pt-40 md:pt-56 pb-40 md:pb-64">
        <Reveal>
          <p className="overline mb-10 md:mb-16 text-[#C9A050]/80">AI · In development</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[7rem] leading-[0.95] tracking-[-0.04em] max-w-[14ch]">
            Craft, meet{" "}
            <span className="font-serif-accent text-[#C9A050]">code.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-16 md:mt-20 text-[#A1A1AA] text-lg md:text-xl max-w-2xl leading-[1.6] font-light">
            A quiet corner of the studio where our editorial thinking meets emerging AI
            tools. New work in this space is on its way — brand systems that learn, films
            that respond, experiments in generative design.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-14 md:mt-16 font-serif-accent italic text-[#C9A050] text-2xl md:text-3xl max-w-2xl leading-[1.4]">
            Coming soon.
          </p>
        </Reveal>
      </section>
    </main>
  );
}
